import transactionsReducer from "./transactionsSlice";

export default transactionsReducer;
